import { MEDIA, type MediaKey } from '@/assets/media';
import type { Expertise, PerfumeAppContent } from '@/content/types';
import { PerfumeApp } from '@/features/mobile/apps/PerfumeApp';
import { cx } from '@/ui/classNames';
import { PhoneFrame } from '@/ui/Device/PhoneFrame';

import styles from './Expertises.module.css';

const IMAGE_BY_VISUAL: Readonly<Record<Exclude<Expertise['visual'], 'app'>, MediaKey>> = {
  architecture: 'architecture',
  monogram: 'portal',
  craft: 'craft',
};

/** Le visuel d'une expertise : une photographie, ou un téléphone pour les applications. */
export function ExpertiseVisual({
  expertise,
  app,
}: {
  readonly expertise: Expertise;
  readonly app: PerfumeAppContent;
}) {
  if (expertise.visual === 'app') {
    return (
      <div className={cx(styles.visual, styles.phoneStage)}>
        <PhoneFrame className={styles.phone} label={expertise.visualAlt}>
          <PerfumeApp content={app} />
        </PhoneFrame>
      </div>
    );
  }

  const media = MEDIA[IMAGE_BY_VISUAL[expertise.visual]];
  return (
    <div className={styles.visual}>
      <img
        src={media.src}
        width={media.width}
        height={media.height}
        alt={expertise.visualAlt}
        loading="lazy"
        decoding="async"
        data-parallax
      />
    </div>
  );
}
